import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core'

@Component({
    selector: 'app-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class InputComponent<T> {
    @Input() formFieldSiblings: TemplateRef<undefined> | undefined

    @Output() selectChanged = new EventEmitter()
    @Input() selectDisabled: boolean | undefined
    @Input() selectShow: boolean | undefined
    @Input() selectShowDisabled: boolean | undefined
    @Input() selectPlaceholder: string | undefined
    @Input() selectMultiple: boolean | undefined
    @Input() selectPanelClass = ''
    @Input() formFieldClass = ''

    @Input() selectOptions: InputSelectOption<T>[] | undefined

    @Input() spinnerShow: boolean | undefined

    @Input() title: string | undefined

    @Input() selectSelected: T | undefined
    @Output() selectSelectedChange = new EventEmitter<T>()
    @Input() selectCompare: (a: T, b: T) => boolean = (a, b) => a === b

    constructor() {}

    onSelectModelChange(newValue: T) {
        this.selectSelected = newValue
        this.selectSelectedChange.emit(newValue)
        this.selectChanged.emit()
    }

    get isSelectDisabled() {
        return this.selectDisabled ?? false
    }

    trackByOption(index: number, asset: InputSelectOption<T>) {
        return asset.value
    }
}
export class InputSelectOption<T> {
    label: string
    value: T
    useInnerHTML: boolean

    constructor(label: string, value: T, useInnerHTML = false) {
        this.label = label
        this.value = value
        this.useInnerHTML = useInnerHTML
    }
}
